import React from 'react';
import { useState, useEffect, useContext } from 'react'

import { Modal, Button } from '@mui/material';

import Icon from '@mdi/react'
import { mdiQrcode } from '@mdi/js'

import {AppBar, CircularProgress, IconButton, Toolbar, Paper, Breadcrumbs, Typography} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Grid, ThemeProvider, StyledEngineProvider} from "@mui/material";

import { AuthContext } from '../../components/AuthContext';
import SnackbarMessage from '../SnackbarMessage'; // Asegúrate de proporcionar la ruta correcta al archivo SnackbarMessage

import MaterialTable from '@material-table/core';

import UserService from "./services/mantenimiento.service";
import { useStyles, theme, direction } from '../styles'; // Importa los estilos desde el archivo styles.js

import QRModal from "../QR/QRModal";

export default function Maquinas(props) {
  const [url, setUrl] = useState("");
  const [modalQR, setModalQR] = useState(false);
  const { OwnedProducts } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(false)

  const styles = useStyles();
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [modalEliminar, setModalEliminar] = useState(false);
  const [consolaSeleccionada, setConsolaSeleccionada] = useState({
    id: '',
    nombre: '',
    codigo: '',
  })
 
  const peticionDelete = async () => {
    const response = await UserService.delMaquina(consolaSeleccionada.id);
    var data = response;
    peticionGet();
    abrirCerrarModalEliminar();
  }

  const peticionGet = async () => {
    const result = await UserService.getMaquinas();
    setData(result);
  }

  const abrirCerrarModalInsertar = () => {
    props.history.push(process.env.PUBLIC_URL + "/maquinasaddmod/")
  }

  const seleccionarConsola = (consola, caso) => {
    setConsolaSeleccionada(consola);
    (caso === 'Editar') ? props.history.push(process.env.PUBLIC_URL + "/maquinasaddmod/" + consola.id) : abrirCerrarModalEliminar()
  }

  const abrirCerrarModalEliminar = () => {
    setModalEliminar(!modalEliminar);
  }
 
  useEffect(() => {

    const GetData = async () => {
      try {
        setIsLoading(true);
        const result = await UserService.getMaquinas();
        if (result) {
          setData(result.data);
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      } catch (e) {
        setIsLoading(false);
        handleShowMessage('500');
      }
    }
    GetData();

  }, []);

  const bodyEliminar = (
    <div className={styles.modal}>
      <p>Estás seguro que deseas eliminar la Maquina <b>{consolaSeleccionada && consolaSeleccionada.nombre}</b> ? </p>
      <div align="right">
        <Button color="secondary" onClick={() => peticionDelete()} >Sí</Button>
        <Button onClick={() => abrirCerrarModalEliminar()}>No</Button>
      </div>
    </div>
  )

  const inicio = () => {
    props.history.push(process.env.PUBLIC_URL + "/mantenimiento")
  }

  const seleccionarQR = (id) => {
    setUrl(id.urlqr);
    abrirCerrarModalQR()
  }

  const abrirCerrarModalQR = () => {
    setModalQR(!modalQR);
  }

  const bodyQR = (
    <div className={styles.modal}>
      <QRModal url={url} />
    </div>
  )

  //Para el uso del componente de mensajes 
  const [open, setOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const handleShowMessage = (message) => {
    setErrorMessage(message);
    setOpen(true);
  };
  const handleCloseMessage = () => {
    setOpen(false);
  };
  //Fin

  return (
    <Paper className={classes.root}>

      <AppBar style={{ background: '#004F9E', alignItems: 'center' }} position="static">
        <Toolbar>
          {isLoading && <CircularProgress color="secondary" />}

          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
            onClick={() => inicio()}
          >
            <ArrowBackIcon style={{ color: '#fff' }} />
          </IconButton>
          <Typography variant="h5" component="div" style={{ color: '#fff' }} sx={{ flexGrow: 1 }}>
            Maquinas
          </Typography>
        </Toolbar>
      </AppBar>
      <br />

      {(
        OwnedProducts.find(product => product.name === "Mantenimiento").modules.find(
          module => module.name === "Maquinas" && (module.permissions.agregar)
        )
        &&
        <Breadcrumbs aria-label="breadcrumb">
          <Button style={{ color: "#fff", backgroundColor: "#004F9E" }} variant="contained" onClick={() => abrirCerrarModalInsertar()}>Nueva Maquina</Button>
        </Breadcrumbs>
      )}

      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <div style={{ maxWidth: "100%", direction }}>
            <Grid container>
              <Grid item xs={12}>

                <MaterialTable
                  title=""

                  localization={{
                    toolbar: {
                      searchPlaceholder: 'Buscar...'
                    },
                    header: {
                      actions: 'Acciones'
                    },
                    body: {
                      editRow: {
                        deleteText: 'Estas seguro de eliminar este registro ?'
                      }
                    },
                  }}

                  columns={[
                    {
                      title: 'Codigo',
                      field: 'codigo',
                    },
                    {
                      title: 'Marca',
                      field: 'marca',
                    },
                    {
                      title: 'Modelo',
                      field: 'modelo',
                    },
                  ]}

                  actions={[
                    {
                      icon: () => <Icon path={mdiQrcode}
                        size={1}
                        horizontal
                        vertical
                        rotate={180}
                        color="#cd561c"
                      />,
                      tooltip: 'Ver QR',
                      onClick: (event, data) => seleccionarQR(data),
                    },

                    OwnedProducts.find(product => product.name === "Mantenimiento").modules.find(
                      module => module.name === "Maquinas" && module.permissions.modificar
                    ) &&
                    {
                      icon: 'edit',
                      tooltip: 'Editar',
                      onClick: (event, data) => seleccionarConsola(data, 'Editar'),
                    },
                    OwnedProducts.find(product => product.name === "Mantenimiento").modules.find(
                      module => module.name === "Maquinas" && module.permissions.eliminar
                    ) &&
                    {
                      icon: 'delete',
                      tooltip: 'Eliminar',
                      onClick: (event, data) => seleccionarConsola(data, 'Eliminar'),
                    }
                  ]}

                  data={data}
                  options={{
                    headerStyle: {
                      backgroundColor: '#004F9E',
                      color: '#FFF',
                    },
                    search: true,
                    actionsColumnIndex: -1
                  }}
                />

                <Modal
                  open={modalEliminar}
                  onClose={abrirCerrarModalEliminar}>
                  {bodyEliminar}
                </Modal>

                <Modal
                  open={modalQR}
                  onClose={abrirCerrarModalQR}>
                  {bodyQR}
                </Modal>

                <SnackbarMessage
                  open={open}
                  message={errorMessage}
                  severity="success"
                  onClose={handleCloseMessage}
                />

              </Grid>
            </Grid>
          </div>
        </ThemeProvider>
      </StyledEngineProvider>

    </Paper>
  );
}